import { cn } from "@/lib/utils";
import { BadgeCheck, Check, Minus, X } from "lucide-react";

export const Logo = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6372 0C5.21506 0 0 5.24968 0 11.7322C0 18.2068 5.20717 23.4645 11.6372 23.4645C18.0594 23.4645 23.2745 18.2148 23.2745 11.7322C23.2745 5.24968 18.0673 0 11.6372 0ZM11.6372 19.7102C7.95277 19.7102 4.84425 17.1569 3.9685 13.7128L6.12237 13.2753C6.79299 15.7093 9.00998 17.5069 11.6372 17.5069C14.7931 17.5069 17.3572 14.9218 17.3572 11.7402C17.3572 11.4857 17.3415 11.247 17.3099 11.0005L19.4638 10.563C19.519 10.9448 19.5506 11.3425 19.5506 11.7402C19.5506 16.1308 16.0002 19.7102 11.6372 19.7102Z"
        fill="white"
      />
    </svg>
  );
};

export const MicrosoftLogo = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="#f35325" d="M1 1h10v10H1z" />
      <path fill="#81bc06" d="M12 1h10v10H12z" />
      <path fill="#05a6f0" d="M1 12h10v10H1z" />
      <path fill="#ffba08" d="M12 12h10v10H12z" />
    </svg>
  );
};

export const VerifiedIcon = ({ className, size = 20 }: { className?: string; size?: number }) => {
  return (
    <div className={`relative h-4 w-4 rounded-full bg-emerald-100 ${className}`}>
      <BadgeCheck
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-emerald-600"
        size={size}
      />
    </div>
  );
};

export const CircleCheckIcon = ({ className, size = 20 }: { className?: string; size?: number }) => {
  return (
    <div className={`bg-primary-100 relative mx-auto h-6 w-6 rounded-full ${className}`}>
      <Check className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-slate-700" size={size} />
    </div>
  );
};

export const CircleCheck2Icon = ({ className, size = 10 }: { className?: string; size?: number }) => {
  return (
    <div className={`relative mx-auto h-4 w-4 rounded-full bg-emerald-700 ${className}`}>
      <Check
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white"
        size={size}
        strokeWidth={4}
      />
    </div>
  );
};

export const CircleXIcon = ({ className, size = 10 }: { className?: string; size?: number }) => {
  return (
    <div className={`mx-auto flex h-4 w-4 items-center justify-center rounded-full bg-rose-700 ${className}`}>
      <X className="text-white" size={size} strokeWidth={4} />
    </div>
  );
};

export const CircleMinusIcon = ({ className, size = 10 }: { className?: string; size?: number }) => {
  return (
    <div className={`mx-auto flex h-4 w-4 items-center justify-center rounded-full bg-transparent ${className}`}>
      <Minus size={size} strokeWidth={4} />
    </div>
  );
};

export const HandoverInboundIcon = ({ className, size = 14 }: { className?: string; size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.25 9.33317L9.91671 11.6665M9.91671 11.6665L7.58337 9.33317M9.91671 11.6665L9.91671 2.33317"
        stroke="#0284C7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.3"
        d="M1.75 4.6665L4.08333 2.33317M4.08333 2.33317L6.41667 4.6665M4.08333 2.33317V11.6665"
        stroke="#0284C7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HandoverOutboundIcon = ({ className, size = 14 }: { className?: string; size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.3"
        d="M12.2499 9.33341L9.91659 11.6667M9.91659 11.6667L7.58325 9.33341M9.91659 11.6667L9.91658 2.33341"
        stroke="#0284C7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 4.66675L4.08333 2.33341M4.08333 2.33341L6.41667 4.66675M4.08333 2.33341V11.6667"
        stroke="#0284C7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HandoverPendingIcon = ({ className, size = 14 }: { className?: string; size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.2499 9.33341L9.91659 11.6667M9.91659 11.6667L7.58325 9.33341M9.91659 11.6667L9.91658 2.33341"
        className="stroke-slate-400"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 4.66675L4.08333 2.33341M4.08333 2.33341L6.41667 4.66675M4.08333 2.33341V11.6667"
        className="stroke-slate-400"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ToolCaseIcon = ({ className, size = 14 }: { className?: string; size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      className={cn("lucide lucide-tool-case-icon lucide-tool-case", className)}
    >
      <path d="M10 15h4" />
      <path d="m14.817 10.995-.971-1.45 1.034-1.232a2 2 0 0 0-2.025-3.238l-1.82.364L9.91 3.885a2 2 0 0 0-3.625.748L6.141 6.55l-1.725.426a2 2 0 0 0-.19 3.756l.657.27" />
      <path d="m18.822 10.995 2.26-5.38a1 1 0 0 0-.557-1.318L16.954 2.9a1 1 0 0 0-1.281.533l-.924 2.122" />
      <path d="M4 12.006A1 1 0 0 1 4.994 11H19a1 1 0 0 1 1 1v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" />
    </svg>
  );
};

export const UserStarIcon = ({ className, size = 14 }: { className?: string; size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      className={cn("lucide lucide-user-star-icon lucide-user-star", className)}
    >
      <path d="M16.051 12.616a1 1 0 0 1 1.909.024l.737 1.452a1 1 0 0 0 .737.535l1.634.256a1 1 0 0 1 .588 1.806l-1.172 1.168a1 1 0 0 0-.282.866l.259 1.613a1 1 0 0 1-1.541 1.134l-1.465-.75a1 1 0 0 0-.912 0l-1.465.75a1 1 0 0 1-1.539-1.133l.258-1.613a1 1 0 0 0-.282-.866l-1.156-1.153a1 1 0 0 1 .572-1.822l1.633-.256a1 1 0 0 0 .737-.535z" />
      <path d="M8 15H7a4 4 0 0 0-4 4v2" />
      <circle cx="10" cy="7" r="4" />
    </svg>
  );
};
